import React, { Component } from 'react'
import Graphics from './Graphics';

import { withTranslation } from 'react-i18next'

import './Tubes.scss'

class EmptyTubeStand extends Component {
    render() {
        return (
            <ul style={{pointerEvents: 'none', zIndex: 2}}>
                <li aria-label={this.props.t("Tube Stand")}
                  id="TubeStand">
                    <Graphics id={this.props.id} />
                </li>
            </ul>
        );
    }
}

export default withTranslation()(EmptyTubeStand);
